export function safeStr(v) {
  if (v === null || v === undefined) return '';
  return String(v);
}

export function getInputValue(arg) {
  if (arg === null || arg === undefined) return '';
  if (typeof arg === 'string' || typeof arg === 'number') return String(arg);
  if (arg?.target && 'value' in arg.target) return safeStr(arg.target.value);
  if (arg && typeof arg === 'object' && 'value' in arg) return safeStr(arg.value);
  return safeStr(arg);
}

export function isSelectableSlug(slug) {
  return slug === 'unique' || slug === 'multiple' || slug === 'logic';
}

export function isDescriptiveSlug(slug) {
  return slug === 'descriptive' || slug === 'text' || slug === 'description';
}

export function isMediaSlug(slug) {
  return slug === 'image' || slug === 'video';
}

export function isPlateSlug(slug) {
  return slug === 'vehicle_plate' || slug === 'wagon_plate' || slug === 'implement_plate';
}

export function hasBackAttachments(q) {
  return Array.isArray(q?.attachments) && q.attachments.length > 0;
}

export function hasLocalFiles(q) {
  const files = q?.attachment?.files;
  return !!files && files.length > 0;
}

export function isAnswered(q) {
  const slug = q?.type?.slug;

  if (!!q?.needAttachment && (hasBackAttachments(q) || hasLocalFiles(q))) return true;

  if (isSelectableSlug(slug)) return (q.responses || []).some((r) => !!r.selected);

  if (isDescriptiveSlug(slug)) {
    const desc = safeStr(q.questionDescriptiveResponse).trim();
    return desc.length > 0;
  }

  if (isPlateSlug(slug)) {
    const plate =
      safeStr(q?.vehicle?.plate) ||
      safeStr(q?.wagon?.plate) ||
      safeStr(q?.questionDescriptiveResponse);
    return plate.trim().length > 0;
  }

  if (isMediaSlug(slug)) return !!q.sentAttachment || hasBackAttachments(q) || hasLocalFiles(q);

  const desc = safeStr(q.questionDescriptiveResponse).trim();
  return (q.responses || []).some((r) => !!r.selected) || desc.length > 0;
}

export function isAttachmentRequiredByBackend(q) {
  const slug = q?.type?.slug;
  const required = !!q?.required;

  if (isMediaSlug(slug)) return required;
  if (q?.needAttachment) return required;

  return false;
}

export function shouldRenderUpload(q) {
  const slug = q?.type?.slug;
  return isMediaSlug(slug) || !!q?.needAttachment;
}
